import type { TransactionDetails } from '@/api/send_detail/model/sendMailModel'

import { TransactionStatusEnum } from '@/enums'

const defaultTransactionDetails: TransactionDetails = {
  transaction: {
    transaction_sequence: '',
    transaction_status: '' as TransactionStatusEnum,
    sender_corporate_id: '',
    sender_product_id: '',
    sender_product_code: '',
    sender_product_name: '',
    sender_corporate_number: '',
    sender_corporate_name: '',
    sender_user_id: '',
    sender_user_name: '',
    sender_department_name: '',
    sender_mail: '',
    sender_folder_id: '',
    recipient_corporate_id: '',
    recipient_client_code: '',
    recipient_client_name: '',
    recipient_corporate_number: '',
    recipient_corporate_name: '',
    recipient_corporate_name_sort: '',
    recipient_user_id: '',
    recipient_user_name: '',
    recipient_department_name: '',
    recipient_mail: '',
    recipient_folder_id: '',
    recipient_folder_name: '',
    issuer_corporate_id: '',
    issuer_product_id: '',
    document_id: '',
    file_id: '',
    document_type: '',
    sent_date: '',
    revision_date: '',
    sender_message: '',
  },

  transaction_status: {
    transaction_sequence: '',
    transaction_status: '' as TransactionStatusEnum,
    receive_user_id: '',
    receive_user_name: '',
    receive_date: '',
    recipient_message: '',
  },

  product: {
    corporate_id: '',
    product_id: '',
    product_type: '',
    sender_corporate_id: '',
    sender_product_id: '',
    issuer_corporate_id: '',
    issuer_product_id: '',
    issuer_corporate_number: '',
    issuer_corporate_name: '',
    issuer_product_code: '',
    issuer_product_name: '',
    issuer_product_english_name: '',
    owner_product_code: '',
    owner_product_name: '',
    owner_product_english_name: '',
    hazardous_materials_category: '',
    notified_substances_category: '',
    poisonous_substances_category: '',
    prtr_law_category: '',
    update_remark: '',
    unit: '',
    material: '',
    use: '',
    remark: '',
  },

  document: {
    corporate_id: '',
    document_id: '',
    document_type: '',
    remark: '',
  },

  file: {
    corporate_id: '',
    document_id: '',
    file_id: '',
    latest_edition_flag: '',
    revision_date: '',
    file_sequence: '',
    file_upload_corporate_id: '',
    file_path: '',
    file_name: '',
    file_size: '',
  },

  product_list: [] as any,

  sender_corporate: {
    corporate_address: "",
    corporate_id: -1,
    inquiry_phone: "",
  }
}

export default defaultTransactionDetails
